import convertFormData from '@module/utils/convertFormData';

import { fetchExtended } from '../../../utils/fetch/client-fetch';
import type { FetchLawScheduleParams, ResLawConsultList } from './type';

export async function fetchPostLawSchedule(data: FetchLawScheduleParams) {
  const res = await fetchExtended(`/v1/form/lawConsult`, {
    method: 'POST',
    body: convertFormData(data),
    credentials: 'include',
  });
  const result = await res.json();

  return result as any;
}

export async function fetchGetLawConsultList(data: { date: string }) {
  const res = await fetchExtended(`/v1/form/lawConsult_list`, {
    method: 'POST',
    body: convertFormData(data),
    credentials: 'include',
  });
  const result = await res.json();

  return result as ResLawConsultList;
}
